import { atom } from "jotai";
import { atomFamily, atomWithStorage } from "jotai/utils";
import { AgentMode } from "@/components/ai/prompt-input/agent-mode";

export const agentExecutionInputAtomFamily = atomFamily((environmentId: string) =>
    atomWithStorage<string>(`environment-agent-input-${environmentId}`, ""),
);

export const agentModeAtomFamily = atomFamily((_environmentId: string) => atom<AgentMode>(AgentMode.Agent));

export const selectedDevRunnerIdAtomFamily = atomFamily((_environmentId: string) => atom<string | null>(null));
